import React, { useState } from 'react';
import { FaHandHoldingHeart, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const FloatingDonateButton = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-6 left-6 z-50">
      {/* Main Floating Button */}
      <button
        onClick={() => navigate('/donate')}
        className="bg-blue-400 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition-all duration-300 transform hover:scale-110 flex items-center gap-2"
      >
        <FaHandHoldingHeart className="text-2xl" />
        <span className="font-semibold">Donate Now</span>
      </button>
    </div>
  );
};

export default FloatingDonateButton; 